module.exports = __webpack_public_path__ + "static/media/Ali_Avatar_Kratos.a1172782.svg";